/**
 * @fileoverview gRPC-Web generated client stub for InkCapture
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.6
// source: icws_proto/icws_api_gateway/logging.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as icws_proto_icws_api_gateway_logging_log_pb from '../../icws_proto/icws_api_gateway/logging/log_pb';


export class LoggingClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorLog = new grpcWeb.MethodDescriptor(
    '/InkCapture.Logging/Log',
    grpcWeb.MethodType.UNARY,
    icws_proto_icws_api_gateway_logging_log_pb.LogRequest,
    icws_proto_icws_api_gateway_logging_log_pb.LogResponse,
    (request: icws_proto_icws_api_gateway_logging_log_pb.LogRequest) => {
      return request.serializeBinary();
    },
    icws_proto_icws_api_gateway_logging_log_pb.LogResponse.deserializeBinary
  );

  log(
    request: icws_proto_icws_api_gateway_logging_log_pb.LogRequest,
    metadata: grpcWeb.Metadata | null): Promise<icws_proto_icws_api_gateway_logging_log_pb.LogResponse>;

  log(
    request: icws_proto_icws_api_gateway_logging_log_pb.LogRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: icws_proto_icws_api_gateway_logging_log_pb.LogResponse) => void): grpcWeb.ClientReadableStream<icws_proto_icws_api_gateway_logging_log_pb.LogResponse>;

  log(
    request: icws_proto_icws_api_gateway_logging_log_pb.LogRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: icws_proto_icws_api_gateway_logging_log_pb.LogResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/InkCapture.Logging/Log',
        request,
        metadata || {},
        this.methodDescriptorLog,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/InkCapture.Logging/Log',
    request,
    metadata || {},
    this.methodDescriptorLog);
  }

}

